<template>
    <div class="SC-split__col" v-if="matches.length > 0">

        <div class="Results-matches">

            <score-card v-for="match in matches"
                        :match="match"
                        :flagPath="flagPath"
                        :key="match.id"
                        :detail="detail"
                        mode="live"
                        :data-id="match.id"
                        :ticket="ticket">
            </score-card>

        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import MatchCard from './MatchCard'

    export default {
        props: ['type', 'flag', 'detail', 'ticket'],
        components: {
            'score-card': MatchCard,
        },
        data() {
            return {
                matches: [],
                feed: [],
                flagPath: this.flag + '/assets/dist/svg/flags/'
            }
        },
        created: function () {

            this.getLive()

            let app = this
            setInterval(function () {
                app.getLive()
            }, 15 * 1000, app)

        },
        methods: {
            showMatch(match) {

                if ( !match.detail )
                    return false

                if ( match.detail.state != 'F' )
                    return true

                return true

            },
            removeFinishedMatches(matches) {

                return matches.filter(function (match) {

                    return match.detail && ( match.detail.state != 'F' )

                })

            },
            getLive() {

                let url = `${window.feed_ip}/get/${this.type}/${window.tournament}/live`

                axios.get( url ).then( response => {

                    this.feed = response.data

                    let liveMatches = response.data

                    liveMatches.sort(function (a, b) {
                        return a.detail.crt - b.detail.crt
                    })

                    this.matches = liveMatches

                }).catch( function ( error ) {
                    console.log( error )
                })

            }
        }
    }
</script>
